import { localized } from "./i18n";

export const sharedMessages = {
  home: localized("Home", "Home"),
  services: localized("Services", "Servizi"),
  about: localized("About", "Chi sono"),
  contact: localized("Contact", "Contatti"),
  demos: localized("Websites", "Siti web"),
  websites: localized("Websites", "Siti web"),
  automations: localized("Systems & Automation", "Sistemi & Automazioni"),
  language: localized("Website language", "Lingua del sito"),
  menuOpen: localized("Open navigation menu", "Apri il menu di navigazione"),
  menuClose: localized("Close navigation menu", "Chiudi il menu di navigazione"),
  discuss: localized("Discuss a project", "Parliamo del progetto"),
  clear: localized("Clear filters", "Azzera filtri"),
  close: localized("Close", "Chiudi"),
  back: localized("Back", "Indietro"),
  continue: localized("Continue", "Continua"),
  save: localized("Save simulated request", "Salva richiesta simulata"),
  synthetic: localized("Interactive demo · Synthetic data", "Demo interattiva · Dati sintetici"),
};

export const homeMessages = {
  greeting: localized("Hi there! 👋", "Ciao! 👋"),
  lead: localized(
    "I build websites and digital systems that help you win more clients — and run a smoother business.",
    "Progetto siti e sistemi digitali per far crescere la tua azienda e semplificare il tuo lavoro.",
  ),
  body: localized(
    "From high-converting websites to custom software, automation, and applied AI, I design practical digital tools built around how your business actually works.",
    "Dai siti web per acquisire clienti ai software su misura, automazioni e IA: creo soluzioni concrete modellate sulle reali esigenze della tua attività.",
  ),
  prompt: localized("Let’s discuss your project.", "Parliamo del tuo progetto."),
  email: localized("Email me", "Scrivimi"),
  explore: localized("Explore websites", "Esplora i siti"),
  servicesEyebrow: localized("What I build", "Cosa realizzo"),
  servicesTitle: localized("Digital experiences outside. Better operations inside.", "Esperienze digitali fuori. Operazioni migliori dentro."),
  servicesIntro: localized(
    "One partner for the experience customers see and the systems your team relies on every day.",
    "Un unico partner per l’esperienza che vedono i clienti e i sistemi su cui il team conta ogni giorno.",
  ),
  capabilities: [
    {
      title: localized("Websites & Digital Experiences", "Siti web ed esperienze digitali"),
      text: localized("Customer-facing websites, commerce, booking, lead generation and online services.", "Siti rivolti ai clienti, e-commerce, prenotazioni, acquisizione contatti e servizi online."),
    },
    {
      title: localized("Custom Business Systems", "Sistemi aziendali su misura"),
      text: localized("Internal tools that organise projects, customers, stock, teams and daily decisions.", "Strumenti interni che organizzano progetti, clienti, magazzino, team e decisioni quotidiane."),
    },
    {
      title: localized("Automation & Applied AI", "Automazione e AI applicata"),
      text: localized("Workflows that remove repetitive work and keep people in control of important actions.", "Flussi che eliminano il lavoro ripetitivo e mantengono le persone al controllo delle azioni importanti."),
    },
    {
      title: localized("Infrastructure & Integrations", "Infrastruttura e integrazioni"),
      text: localized("Reliable foundations and connections between the tools your business already uses.", "Fondamenta affidabili e connessioni tra gli strumenti che la tua azienda utilizza già."),
    },
  ],
  catalogueEyebrow: localized("Websites", "Siti web"),
  catalogueTitle: localized("Websites built to be chosen.", "Siti web progettati per farsi scegliere."),
  catalogueText: localized(
    "Explore complete website concepts for businesses that need to be understood, trusted and easy to contact.",
    "Esplora concept completi per attività che devono farsi capire, scegliere e contattare con facilità.",
  ),
  catalogueAction: localized("Explore websites", "Esplora i siti"),
  processEyebrow: localized("How I work", "Come lavoro"),
  processTitle: localized("Clear thinking. Useful software.", "Pensiero chiaro. Software utile."),
  process: [
    { title: localized("Understand", "Comprendere"), text: localized("Map the people, decisions and friction behind the brief.", "Mappare persone, decisioni e attriti dietro la richiesta.") },
    { title: localized("Make it tangible", "Renderlo concreto"), text: localized("Prototype the important journeys before complexity arrives.", "Prototipare i percorsi importanti prima che arrivi la complessità.") },
    { title: localized("Build & improve", "Costruire e migliorare"), text: localized("Ship a maintainable solution and learn from real use.", "Rilasciare una soluzione mantenibile e imparare dall’uso reale.") },
  ],
  aboutEyebrow: localized("A practical partner", "Un partner pratico"),
  aboutTitle: localized("Technology should make the business clearer, not more complicated.", "La tecnologia dovrebbe rendere l’azienda più chiara, non più complicata."),
  aboutText: localized(
    "I combine product thinking, interface design and software engineering to take an idea from the first workflow to a maintainable release.",
    "Unisco pensiero di prodotto, progettazione dell’interfaccia e sviluppo software per portare un’idea dal primo flusso a un rilascio mantenibile.",
  ),
  contactEyebrow: localized("Have something in mind?", "Hai qualcosa in mente?"),
  contactTitle: localized("Let’s make the next step clear.", "Facciamo chiarezza sul prossimo passo."),
  contactText: localized("Tell me what you need to improve and I’ll get back to you directly.", "Raccontami cosa vuoi migliorare e ti risponderò direttamente."),
  vat: localized("VAT: IT03233180649", "P. IVA: 03233180649"),
};

export const catalogueMessages = {
  eyebrow: localized("Websites", "Siti web"),
  title: localized("Websites built around your business.", "Siti costruiti intorno alla tua attività."),
  intro: localized(
    "From professional sites and portfolios to bookings, e-commerce and custom web applications, I design each project around your identity, customers and goals.",
    "Da siti professionali e portfolio a prenotazioni, e-commerce e applicazioni web su misura, progetto ogni esperienza intorno alla tua identità, ai tuoi clienti e ai tuoi obiettivi.",
  ),
  neutralTitle: localized("Examples, not templates.", "Esempi, non template."),
  neutralText: localized(
    "These demos show different ways a business can be presented, structured and turned into action online.",
    "Queste demo mostrano diversi modi di presentare un’attività, organizzarne i contenuti e trasformare l’interesse online in un’azione concreta.",
  ),
  search: localized("Search demos", "Cerca demo"),
  searchPlaceholder: localized("Industry, workflow or capability…", "Settore, flusso o funzionalità…"),
  allCategories: localized("All categories", "Tutte le categorie"),
  websites: localized("Websites", "Siti web"),
  systems: localized("Business Systems & Automation", "Sistemi aziendali e automazione"),
  industry: localized("Industry", "Settore"),
  solution: localized("Solution type", "Tipo di soluzione"),
  need: localized("Business need", "Esigenza aziendale"),
  allIndustries: localized("All industries", "Tutti i settori"),
  allSolutions: localized("All solution types", "Tutti i tipi di soluzione"),
  allNeeds: localized("All business needs", "Tutte le esigenze"),
  filters: localized("Filters", "Filtri"),
  results: localized("{count} concepts shown", "{count} concept mostrati"),
  emptyTitle: localized("No concepts match those filters.", "Nessun concept corrisponde ai filtri."),
  emptyText: localized("Clear the filters or try a broader search.", "Azzera i filtri o prova una ricerca più ampia."),
  concept: localized("Concept demo", "Demo concept"),
  brand: localized("Fictional brand", "Brand immaginario"),
  capabilities: localized("Capabilities", "Funzionalità"),
  open: localized("Open interactive demo", "Apri la demo interattiva"),
  related: localized("Also suitable for", "Adatto anche a"),
  closeFilters: localized("Apply filters", "Applica filtri"),
};

export const demoMessages = {
  byline: localized("Interactive concept by Mattia D’Elia", "Concept interattivo di Mattia D’Elia"),
  all: localized("All demos", "Tutte le demo"),
  discuss: localized("Discuss a similar project", "Parliamo di un progetto simile"),
  reset: localized("Reset demo", "Reimposta demo"),
  resetConfirm: localized("Reset this demo to its original synthetic data? This cannot be undone.", "Ripristinare questa demo ai dati sintetici iniziali? L’operazione non può essere annullata."),
  resetCancel: localized("Keep my changes", "Mantieni le modifiche"),
  resetAction: localized("Reset to original data", "Ripristina i dati iniziali"),
  about: localized("About this demo", "Informazioni sulla demo"),
  aboutTitle: localized("A working concept, not a live service.", "Un concept funzionante, non un servizio reale."),
  aboutText: localized(
    "All people, companies and records are synthetic. Changes are stored only in this browser. No booking, payment, message, signature, AI request or other external action is sent.",
    "Tutte le persone, aziende e registrazioni sono sintetiche. Le modifiche vengono salvate solo in questo browser. Nessuna prenotazione, pagamento, messaggio, firma, richiesta AI o altra azione esterna viene inviata.",
  ),
  aboutDesign: localized(
    "This interface demonstrates capabilities and workflow logic, not a visual template. A real solution would be designed around your brand and operating context.",
    "Questa interfaccia dimostra funzionalità e logica dei flussi, non un template visivo. Una soluzione reale verrebbe progettata intorno al tuo brand e contesto operativo.",
  ),
  browserOnly: localized("Changes remain in this browser", "Le modifiche restano in questo browser"),
  finalKicker: localized("Built around your business, not a template.", "Costruito intorno alla tua azienda, non a un template."),
  finalTitle: localized("Could this work for your business?", "Potrebbe funzionare per la tua attività?"),
  finalText: localized("This concept can be adapted to your workflows, customers and existing systems.", "Questo concept può essere adattato ai tuoi flussi, clienti e sistemi esistenti."),
  discussProject: localized("Discuss a similar project", "Parliamo di un progetto simile"),
  exploreOther: localized("Explore other demos", "Esplora altre demo"),
};
